import { render } from "./AddStaff.vue?vue&type=template&id=126b3ca2"
import script from "./AddStaff.vue?vue&type=script&lang=js"
export * from "./AddStaff.vue?vue&type=script&lang=js"

import "./AddStaff.vue?vue&type=style&index=0&id=126b3ca2&lang=scss"
script.render = render

export default script